import React from 'react';
import Nav from '../components/Nav/Nav';
import Footer from '../components/Footer/Footer';

export default function LayoutTemplate({ showNav, footerStyle, children }) {
  const isRegularFooter =
    typeof footerStyle === 'undefined' ||
    footerStyle === null ||
    footerStyle !== false;
  return (
    <div>
      {typeof showNav === 'undefined' || showNav === null || showNav ? (
        <Nav />
      ) : null}
      <main>{children}</main>
      <Footer isRegularFooter={isRegularFooter} />
    </div>
  );
}
